import {
    BACKEND_CREATE_EMPLOYMENT,
    BACKEND_UPDATE_EMPLOYMENT,
    STORE_UPDATE_EMPLOYMENT_SUCCESS,
} from '@perpay-web/fintech/constants/actionTypes';

export function profileUpdateJob(uuid, name, payCycle) {
    return {
        type: BACKEND_CREATE_EMPLOYMENT,
        payload: {
            name,
            uuid,
            payCycle,
        },
    };
}

export function profileUpdatePaycycle(uuid, payCycle, name) {
    return {
        type: BACKEND_UPDATE_EMPLOYMENT,
        payload: {
            name,
            uuid,
            payCycle,
        },
    };
}

export function profileUpdatePaycycleSuccess() {
    return { type: STORE_UPDATE_EMPLOYMENT_SUCCESS };
}
